import { createAuthClient } from 'better-auth/client';

/** A provider start that only answers with the authorization URL; the application returns to its root either way. */
const googleStart = { provider: 'google', callbackURL: '/', errorCallbackURL: '/', disableRedirect: true };

/** SDK runtime bridge; the TypeScript gateway validates every unknown result. */
export function createBrowserAuthClient() {
  // The SDK's default fetch plugin assigns window.location itself whenever a
  // response carries redirect:true. It is switched off so that navigation is
  // decided only by the gateway; no call below relies on it.
  const client = createAuthClient({ basePath: '/api/auth', disableDefaultFetchPlugins: true });
  return {
    getSession: () => client.getSession(),
    signIn: (input) => client.signIn.email(input),
    signUp: (input) => client.signUp.email({ ...input, callbackURL: '/' }),
    requestPasswordReset: (email) => client.requestPasswordReset({ email, redirectTo: '/reset-password' }),
    resetPassword: (input) => client.resetPassword(input),
    resendVerification: (email) => client.sendVerificationEmail({ email, callbackURL: '/' }),
    // A same-origin JSON POST, which the server's Origin check requires. The
    // server answers with the provider authorization URL and redirect:false;
    // the gateway validates that URL before it navigates.
    signInWithGoogle: () => client.signIn.social({ ...googleStart }),
    // The same start for linking Google to the account that is signed in.
    linkGoogle: () => client.linkSocial({ ...googleStart }),
    signOut: () => client.signOut(),
  };
}
